import React from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import example1Mobile from "../../../../../assets/video_authentisierung/authentifizierung-1-mobile.png";
import example2Mobile from "../../../../../assets/video_authentisierung/authentifizierung-2-mobile.png";
import example1 from "../../../../../assets/video_authentisierung/authentifizierung-1.png";
import example2 from "../../../../../assets/video_authentisierung/authentifizierung-2.png";
import CaptureHints from "./CaptureHints";
import { NavControls } from "./NavControls";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
  },
  topSection: {
    flexShrink: 0,
    marginBottom: theme.spacing(2),
  },
  middleSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
    marginBottom: theme.spacing(2),
  },
  imageContainer: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  image: {
    maxWidth: "90%",
    maxHeight: "90%",
    objectFit: "contain",
  },
  bottomSection: {
    marginTop: "auto"
  },
}));

interface CaptureInstructionsProps {
  modeCardIDCapture: boolean;
  onContinue: () => void;
  isMobileOrIpad: boolean;
}

export const CaptureInstructions: React.FC<CaptureInstructionsProps> = ({
  modeCardIDCapture,
  onContinue,
  isMobileOrIpad,
}) => {
  const classes = useStyles();

  const imageSrc = isMobileOrIpad
    ? modeCardIDCapture
      ? example2Mobile
      : example1Mobile
    : modeCardIDCapture
    ? example2
    : example1;

  return (
    <Box className={classes.root}>
      <Box className={classes.topSection}>
        <CaptureHints
          modeCardIDCapture={modeCardIDCapture}
          isMobileOrIpad={isMobileOrIpad}
        />
      </Box>
      <Box className={classes.middleSection}>
        <Box className={classes.imageContainer}>
          <img src={imageSrc} alt="Example" className={classes.image} />
        </Box>
      </Box>
      <Box className={classes.bottomSection}>
        <NavControls canProceed onProceed={onContinue} />
      </Box>
    </Box>
  );
};
